module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/profile/login-change/login-change.scss
// module id = ./web/modern/components/settings/profile/login-change/login-change.scss
// module chunks = 0